// import { Drawer, Hidden } from '@material-ui/core';
// import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types'
import { memo, useCallback, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
// import { backend } from 'src/config';
import { setDynamicNavState } from 'src/slices/dynamic-navigation'
import { useDispatch, useSelector } from 'src/store'
import foundLastNavigatedPath from 'src/utils/addLastNavigatedPath'
// import axios from 'src/utils/axios';
import { useMemo } from 'react'
import { Link } from 'react-router-dom'
import useRouter from 'src/hooks/useRouter'
// import { Button, Collapse, ListItem } from '@material-ui/core';
import { Button } from '@material-ui/core'
import {
  ExpandMore as ExpandMoreIcon,
  KeyboardArrowRight as KeyboardArrowRightIcon,
} from '@material-ui/icons/'
import clsx from 'clsx'
import useAuth from 'src/hooks/useAuth'
import useWindowSize from 'src/hooks/useWindowSize'
import { checkValuesInArray, collectAllItems } from 'src/utils'
import sections from './NavBarData'
// import NavBarSubContent from './NavBarSubContent';
// import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import styles from './styles.module.scss'
import SubItem from './SubItem'
import useStyles from './sxStyles.sx'

const NavBar = ({ onMobileClose, isMobileNavOpen }) => {
  const sxStyles = useStyles()
  const { pathname } = useRouter()
  const dispatch = useDispatch()
  const { navigationState } = useSelector((state) => state.navigationState)
  const { user } = useAuth()
  const history = useHistory()
  const [currentTabHref, setCurrentTabHref] = useState('')
  const { isMd } = useWindowSize()

  const found = foundLastNavigatedPath(location.pathname, sections)

  const handleChangeNavigationState = useCallback(() => {
    if (
      found &&
      !(navigationState.filter((el) => el.href === found.href).length > 0)
    ) {
      if (navigationState.length < 43) {
        dispatch(setDynamicNavState([...navigationState, found]))
      } else {
        const arr = [...navigationState]
        arr.shift()
        dispatch(setDynamicNavState(arr))
      }
    }
  }, [dispatch, found, navigationState])

  useEffect(() => {
    handleChangeNavigationState()
  }, [found, dispatch, navigationState, handleChangeNavigationState])

  const href = useMemo(() => {
    const arrayOfPath = pathname.split('/')
    const path = `/${arrayOfPath[1]}/${arrayOfPath[2]}`
    return path
  }, [pathname])

  useEffect(() => {
    setCurrentTabHref(href)
  }, [href])

  const onClick = () => {
    const arrayOfPath = pathname.split('/')
    const href = `/${arrayOfPath[1]}/${arrayOfPath[2]}`
    setCurrentTabHref((prev) => (prev === href ? '' : href))
  }

  useEffect(() => {
    const allItems = collectAllItems(sections)
    const exactLocation = allItems?.find((item) => item.href === pathname)
    const routeAllowed = exactLocation?.allowedRoles?.includes(user?.role)
    if (routeAllowed === false) {
      // routeAllowed CAN BE UNDEFINED, SO CHECK FOR FALSE
      history.push('/404')
    }
  }, [history, pathname, user])

  return (
    <div className={styles.container}>
      <div
        className={isMobileNavOpen ? styles.cover : ''}
        onClick={onMobileClose}
      />
      <div
        className={clsx(
          styles.content,
          isMd ? (isMobileNavOpen ? styles.open : styles.close) : {}
        )}>
        {isMd && <h1 className={styles.projectName}>Dobropost</h1>}
        {sections.map((item) => {
          const isSelected = currentTabHref === item.href
          const Icon = item.icon

          const checkFindValidIndex = () => {
            // THIS FN PUSHES TO THE NEAREST ROUTE, IF THE ROUTE HAS ALLOWED ROLE, IF NOT CHECKS FURTHER
            let validIndex = 0
            while (validIndex < item.items.length) {
              if (
                checkValuesInArray(
                  item.items[validIndex].allowedRoles,
                  user?.roles
                )
              ) {
                return item.items[validIndex].href
              }
              validIndex++
            }
            return item.items[0].href // Fallback to first item if none are allowed
          }

          return checkValuesInArray(item.allowedRoles, user?.roles) ? (
            <Link key={item.href} to={checkFindValidIndex()}>
              <Button
                className={clsx(sxStyles.button, isSelected && sxStyles.active)}
                onClick={onClick}>
                <div className={styles.iconContainer}>
                  <Icon className={sxStyles.icon} size="20" />
                  <span className={sxStyles.title}>{item.title}</span>
                </div>
                {isSelected ? <ExpandMoreIcon /> : <KeyboardArrowRightIcon />}
              </Button>
              {isSelected && (
                <SubItem
                  onMobileClose={onMobileClose}
                  key={item.href}
                  items={item.items}
                />
              )}
            </Link>
          ) : (
            <></>
          )
        })}
      </div>
    </div>
  )

  // const found = foundLastNavigatedPath(location.pathname, sections);

  // const handleChangeNavigationState = useCallback(() => {
  //   if (
  //     found &&
  //     !(navigationState.filter((el) => el.href === found.href).length > 0)
  //   ) {
  //     if (navigationState.length < 43) {
  //       dispatch(setDynamicNavState([...navigationState, found]));
  //     } else {
  //       const arr = [...navigationState];
  //       arr.shift();
  //       dispatch(setDynamicNavState(arr));
  //     }
  //   }
  // }, [dispatch, found, navigationState]);

  // const getCurrentRole = useCallback(async () => {
  //   try {
  //     const user = await axios.get(`${backend}/api/auth/current-user`);
  //     setCurrentRole(user?.data?.role);
  //   } catch (error) {
  //     enqueueSnackbar('Не удалось получить роль', {
  //       variant: 'error'
  //     });
  //   }
  // }, [enqueueSnackbar]);

  // useEffect(() => {
  //   getCurrentRole();
  // }, [getCurrentRole]);

  // useEffect(() => {
  //   handleChangeNavigationState();
  // }, [found, dispatch, navigationState, handleChangeNavigationState]);

  // return (
  //   <>
  //     <Hidden lgUp>
  //       <Drawer
  //         anchor="left"
  //         classes={{ paper: sxStyles.mobileDrawer }}
  //         onClose={onMobileClose}
  //         open={openMobile}
  //         variant="temporary">
  //         <NavBarSubContent
  //           items={menuNavbar}
  //           pathname={location.pathname}
  //           setMenuNavbar={setMenuNavbar}
  //           role={currentUser}
  //         />
  //       </Drawer>
  //     </Hidden>
  //     <Hidden mdDown>
  //       <Drawer
  //         anchor="left"
  //         classes={{ paper: sxStyles.desktopDrawer }}
  //         open
  //         variant="persistent">
  //         <NavBarSubContent
  //           items={menuNavbar}
  //           pathname={location.pathname}
  //           setMenuNavbar={setMenuNavbar}
  //           role={currentUser}
  //         />
  //       </Drawer>
  //     </Hidden>
  //   </>
  // );
}

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
}

export default memo(NavBar)
